























































































































































import { Component, Vue, Mixins } from 'vue-property-decorator';
import UserMethods from '@/mixins/UserMethods.vue';
import { Mutations, Actions, ImageCropperTargets } from '@/ts/store/Constants';
import MobileUserInfoConnectedUsers from './MobileUserInfoConnectedUsers.vue';
import PersonData from '@/ts/PersonData';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { Validator } from 'vee-validate';

const dict = {
    custom: {
        firstname: {
            required: 'It is required to enter a first name.',
            min: 'Your first name must be longer that 2 characters.',
        },
        familyname: {
            required: 'It is required to enter a family name.',
            min: 'Your family name must be longer that 2 characters.',
        },
        email: {
          required: 'It is required to enter a email.',
          email: 'Your email must be a valid email.',
        },
        phonenumber: {
            required: 'It is required to enter a phone number.',
            numeric: 'Your phone number must be numbers, not letters.',
            min: 'Your phone number cannot be less than 8 characters.',
            max: 'Your phone number cannot be more than 8 characters.',
        },
        address: {
            required: 'It is required to enter a address.',
            min: 'Your addres cannot be less than 4 characters.',
        },
        city: {
            required: 'It is required to enter a city.',
            min: 'Your city cannot be less than than 2 characters.',
        },
        zipcode: {
            required: 'It is required to enter a zip code.',
            min: 'Your zip code cannot be less than 4 characters.',
            max: 'Your zip code cannot be more than 4 characters.',
        },
    },
};

Validator.localize('en', dict);

@Component({
    components: {
        MobileUserInfoConnectedUsers,
        VuePhoneNumberInput,
    },
})
export default class MobileUserEditInfo extends Mixins(UserMethods, InputFieldMethods) {

    private errorMsg: string = '';

    public beforeCreate() {
        this.$store.commit(Mutations.SET_HEADER_TEXT, Vue.i18n.translate('header.edit-profile', 'Edit profile'));
        this.$store.commit(Mutations.SET_BOTTOM_MENU_VISIBILITY, false);
        this.$store.commit(Mutations.SET_RIGHT_HEADER_BUTTON, '');
        this.$store.dispatch(Actions.CLONE_CURRENT_USER);

    }

    public beforeDestroy() {
        this.$store.commit(Mutations.SET_BOTTOM_MENU_VISIBILITY, true);
        this.$store.commit(Mutations.SET_HEADER_TEXT, Vue.i18n.translate('header.profile', 'Profile'));
        this.$store.commit(Mutations.SET_RIGHT_HEADER_BUTTON, 'HococoEditButton');
    }

    public checkCloned() {
        // validate whether data has changed
        if (
            this.clonedUser.zipCode     !== this.zipcode
         || this.clonedUser.city        !== this.city
         || this.clonedUser.address     !== this.address
         || this.clonedUser.email       !== this.email
         || this.clonedUser.firstName   !== this.firstName
         || this.clonedUser.familyName  !== this.familyName
         || this.clonedUser.phoneNumber !== this.phoneNumber
        ) {
            return true;
        }

        // no changes, return false
        return false;
    }

    public updateUser() {

        if (this.checkCloned()) {
            this.$validator.validateAll().then(() => {
                if (!this.errors.any()) {
                    this.errorMsg = 'Your changed fields have been submitted';
                    this.$store.dispatch(Actions.UPDATE_USER);
                }
            });
        }

        if (!this.checkCloned()) {
            this.errorMsg = 'There has been no changes in any fields';
        } else {
            if (this.errors.any()) {
                if (this.errors.count() > 1) {
                    this.errorMsg = 'You have ' + this.errors.count() + ' errors left to fix before submiting';
                } else {
                    this.errorMsg = 'You have ' + this.errors.count() + ' error left to fix before submiting';
                }
            }
        }
    }

    get clonedUser(): PersonData {
        return this.$store.getters['User/getClonedUser'];
    }

    public showImageCropper() {
        this.$store.commit(Mutations.SHOW_IMAGE_CROPPER, ImageCropperTargets.ProfileImage);
    }

    public showChangePassword() {
        this.$store.commit(Mutations.SHOW_CHANGE_PASSWORD);
    }
}
